import type { RootState } from '@/store';

import type { EstadoSimulacao } from '../types';
import { selectEstadoDaSimulacao as estadoDaFeature } from './selectors';
import { comandosDaSuperficie, simulacaoAdminService, simulacaoService } from './services';

/**
 * Os serviços da superfície em que a tela está. No admin, a atual é a do escritório escolhido, e a
 * de outro agente na mesma conta não é desta tela. O principal pode mudar no rascunho sem mudar
 * a identidade do agente nem a configuração congelada da execução anterior.
 */
export const servicosDaSimulacao = (state: RootState) => {
  const { superficie, escritorioId, contextoAdmin, configuracaoAdmin } = estadoDaFeature(state);
  if (superficie !== 'ADMIN') {
    return { ...comandosDaSuperficie('ESCRITORIO'), buscarAtual: simulacaoService.buscarAtual };
  }
  const configuracao = configuracaoAdmin.dados;
  return {
    ...comandosDaSuperficie('ADMIN'),
    buscarAtual: async (): Promise<EstadoSimulacao | null> => {
      if (!escritorioId || !configuracao || configuracao.flowId !== contextoAdmin?.flowId)
        return null;
      const atual = await simulacaoAdminService.buscarAtual(escritorioId);
      if (
        !atual?.fluxoInicialId ||
        atual.escritorioId !== escritorioId ||
        configuracao.escritorioId !== escritorioId
      )
        return null;
      const mesmoContexto =
        configuracao.agenteId !== null
          ? atual.agenteId === configuracao.agenteId
          : atual.agenteId === null && atual.fluxoInicialId === configuracao.flowId;
      return mesmoContexto ? atual : null;
    },
  };
};
